import { Schema } from "@comparaonline/products-schema";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";

import { theme } from "../../../../../lib/materialUI/theme";

export const useFeaturedProps = () => {
  const formatMessage = useFormatMessage();
  const props = {
    contrastColor: theme.palette.common.white,
    description: formatMessage("product.featured.recommended.description"),
    label: formatMessage("product.featured.recommended.label"),
    mainColor: theme.palette.secondary.dark
  };
  return (product: Schema.ProductListProduct) => (product.partner ? props : undefined);
};
